import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
    distributor: undefined,
    items: {},
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        setDistributor(state, action) {
            const nextDistributor = action.payload;

            if (!nextDistributor) {
                state.distributor = undefined;
                state.items = {};
                return;
            }

            if (state.distributor?.id !== nextDistributor.id) {
                state.items = {};
            }

            state.distributor = nextDistributor;
        },
        upsertItem(state, action) {
            const { id, qty, ...rest } = action.payload;

            if (qty <= 0) {
                delete state.items[id];
                return;
            }

            state.items[id] = { id, qty, ...rest };
        },
        removeItem(state, action) {
            delete state.items[action.payload];
        },
        clearCart() {
            return initialState;
        },
    },
});

export const { setDistributor, upsertItem, removeItem, clearCart } = cartSlice.actions;

const selectOrdersState = (state) => state.orders ?? {};

const selectCartState = createSelector(selectOrdersState, (ordersState) => ordersState.cart ?? initialState);

export const selectCartDistributor = createSelector(selectCartState, (cartState) => cartState.distributor);

export const selectCartItems = createSelector(selectCartState, (cartState) => Object.values(cartState.items));

export const selectCartTotalQuantity = createSelector(selectCartItems, (items) =>
    items.reduce((total, item) => total + item.qty, 0),
);

export const selectCartTotalPrice = createSelector(selectCartItems, (items) =>
    items.reduce((total, item) => total + (item.price || 0) * item.qty, 0),
);

export default cartSlice.reducer;
